<template>
    <b-container class="h-100">
        <b-row fluid="md" align-v="center" class="h-100">
            <b-col>
                <b-row align-v="center" class="mh-100vh">
                    <b-col offset-md="3" md="6" class="mt-3">
                        <b-img :src="urlBaseS3 + '/header/logo-movired-rojo.png'" alt="Logo Movired" class="logo" center
                            height="25" />
                    </b-col>
                    <b-col offset-md="3" md="6">
                        <h5 class="text-center text-bold">Verifica los datos de tu compra</h5>
                    </b-col>
                    <b-col offset-md="3" md="6" v-if="transaccionCliente">
                        <trx-resumen-app-red></trx-resumen-app-red>
                    </b-col>

                    <!-- <b-col offset-md="3" md="6" v-if="bloquear" class="mb-5">
                        <spinner></spinner>
                    </b-col> -->

                    <!-- <pago-a-red :enlace="enlace" v-if="calculoHoraLink() == 1 && !bloquear && transaccionCliente">
                    </pago-a-red>
                    <pago-b-red :enlace="enlace" v-if="calculoHoraLink() == 2 && !bloquear && transaccionCliente">
                    </pago-b-red> -->

                    <pago-a-red></pago-a-red>

                    <pago-hites></pago-hites>
                </b-row>
            </b-col>
            <!-- <b-col md="12">
                <b-button @click="levantarIframe()">Generar iframe</b-button>
            </b-col> -->
        </b-row>

        <!-- <iframe v-if="presionado == 1" :src="url" frameborder="0" width="100%" height="600px"></iframe> -->

    </b-container>
</template>

<script>
import { BRow, BCol, BContainer, BCard, BTableSimple, BTr, BTd, BButton, BImg } from 'bootstrap-vue';
import { mapActions, mapMutations, mapState } from "vuex";
import mixinAppRed from '../../../plugins/mixinAppRed';


export default {
    mixins: [mixinAppRed],
    props: {
        producto: {
            type: Number,
            value: null
        },
        datos: {
            type: Object,
            value: null
        }
    },
    data() {
        return {
            presionado: 0,
            url: null
        };
    },
    components: {
        BRow,
        BCol,
        BContainer,
        BCard,
        BTableSimple,
        BTr,
        BTd,
        BButton,
        BImg,
        Spinner: () =>
            import(
                /* webpackChunkName: "spinner", webpackPrefetch: true */ "../../../components/spinner/Spinner.vue"
            ),
        PagoARed: () =>
            import(
                /* webpackChunkName: "pagoARed", webpackPrefetch: true */ "../../../components/pagos/PagoARed.vue"
            ),
        PagoBRed: () =>
            import(
                /* webpackChunkName: "pagoBRed", webpackPrefetch: true */ "../../../components/pagos/PagoBRed.vue"
            ),
        TrxResumenAppRed: () => import(
                /* webpackChunkName: "trxResumenAppRed", webpackPrefetch: true */ "../../../components/resumen/TrxResumenAppRed.vue"
        ),
        PagoHites: () =>
            import(
                /* webpackChunkName: "pagoHites", webpackPrefetch: true */ "../../../components/pagos/PagoHites.vue"
            ),
    },
    namespaced: true,
    computed: {
        ...mapState(["rutMiClub", "transaccion", "token", "transaccionCliente", "estadoTransaccion", "bloquear", "configuracionCliente", "urlBaseS3", "configuracionClienteBase"]),
        enlace() {
            if (this.producto == 34) {
                return "https://www.puntototalredtransaccional.cl/PAT/Core/canalWebJJD/BipABT/?nbip=" + this.datos.nbip + "&run=" + this.datos.run + "&dv=" + this.datos.dv + "&monto=" + this.datos.monto + "&mail=" + this.datos.mail + "&urlexito=" + this.datos.urlexito + "&urlfalla=" + this.datos.urlfalla;
            }

            return "https://www.puntototalredtransaccional.cl/PAT/Core/canalWebJJD/BipRA/?nbip=" + this.datos.nbip + "&monto=" + this.datos.monto + "&mail=" + this.datos.mail + "&urlexito=" + this.datos.urlexito + "&urlfalla=" + this.datos.urlfalla;
        }
    },
    methods: {
        ...mapActions(["resetearDatos", "actualizarConfiguracionCliente", "actualizarTransaccionRecibida", "actualizarTransaccionRecibidaCliente"]),
        ...mapMutations(["bloquearFalse", "bloquearTrue"]),
        ...mapActions('configuracion', ['obtenerConfiguracion']),
        async levantarIframe() {
            let resVerificacionPago = await axios.post(
                "/api/generar/recarga",
                {
                    session_id: this.$store.state.transaccion,
                    origin_bank_id: null,
                },
                {
                    headers: {
                        Authorization: `Bearer ${this.$store.state.token}`,
                    },
                }
            );

            this.url = "https://webview.fintoc.com/widget.html?public_key=" + process.env.MIX_APP_TOKEN_FINCTOC + "&holder_type=individual&product=payments&country=cl&widget_token=" + resVerificacionPago.data.widget_token;
            this.presionado = 1
        },
        async listarConfiguracionCliente() {

            let resClienteConfiguracion = await axios.post("/api/configuracion/cliente", {
                navigation_url: this.$router.currentRoute.path
            });

            if (resClienteConfiguracion.status == 200) {
                if (resClienteConfiguracion.data) {
                    this.actualizarConfiguracionCliente(resClienteConfiguracion.data)
                } else {
                    this.actualizarConfiguracionCliente(this.configuracionClienteBase)
                }
            }

            console.log(resClienteConfiguracion.data)

            let productoCliente = this.buscarProducto(this.configuracionCliente.productos, this.producto).identificador;

            let resToken = await axios.post("/api/generar/token", {
                cliente_id: resClienteConfiguracion.data.cliente
            });

            if (resToken.data.token) {
                let resTransaccion = await axios.post("/api/generar/transaccion", {
                    producto_cliente: productoCliente,
                    nro_tarjeta: this.producto == 34 ? this.datos.run + this.datos.dv : this.datos.nbip,
                    monto: this.datos.monto,
                    email: this.datos.mail,
                    enlace: this.calculoHoraLink(),
                    session_cliente_id: resClienteConfiguracion.data.cliente
                },
                    {
                        headers: { Authorization: `Bearer ${resToken.data.token}` }
                    }
                );

                if (resTransaccion.status == 200) {
                    if (resTransaccion.data.estado == true) {
                        this.actualizarTransaccionRecibida({
                            token: resToken.data.token,
                            transaccion: resTransaccion.data.session_id,
                            transaccionCliente: {
                                numero: this.producto == 34 ? this.datos.run + this.datos.dv : this.datos.nbip,
                                monto: this.datos.monto,
                                correo: this.datos.mail,
                                identificador_pro: this.producto,
                                identificador: resTransaccion.data.identificador
                            },
                            producto_cliente: productoCliente,
                            identificador_pro: this.producto
                        })

                        this.bloquearFalse()
                    } else {
                        this.bloquearTrue()
                        //this.mostrarMensajeError(resTransaccion.data.mensaje_cliente)
                        window.location.href = "https://appred.tstgo.cl/v7/phone/payment/orcens/error"
                    }
                }
            } else {
                //this.mostrarMensajeError()
                window.location.href = "https://appred.tstgo.cl/v7/phone/payment/orcens/error"
            }
        }
    },
    mounted() {
        this.resetearDatos()
        this.bloquearTrue()

        /* window.addEventListener("resize", (e) => {
            console.log("Virtual keyboard detected!!!")
        }); */
    },
    created() {
        this.obtenerConfiguracion(this.$router.currentRoute.path)
        this.listarConfiguracionCliente()
        /*
            if (this.transaccionCliente == null) {
                window.location.replace(this.configuracionCliente ? this.configuracionCliente.navigation_url : '/')
            }

            if (this.estadoTransaccion == true) {
                this.$router.push({ name: 'estadoPago' })
            }
        */

        /* iframe.onload = () => {
            this.formloadCounter += 1
            console.log('iframe has been loaded:' + this.formloadCounter + ' times.')
            if (this.formloadCounter > 1) {
                //do stuff
            }
        } */
    },
    /* beforeRouteLeave(to, from, next) {
        if (this.bloquear == true && this.estadoTransaccion == false) {
            next(false)
        } else {
            next()
        }
    }, */
};
</script>

<style scoped>
@import "~bootstrap/dist/css/bootstrap.css";

.table-sm th,
.table-sm td {
    word-break: break-word !important;
}

@font-face {
    font-family: bariol;
    font-display: swap;
    src: url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff2") format("woff2"),
        url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff") format("woff");
}

table {
    font-weight: text-bold;
}

body,
.fondo-tr {
    background-color: #eaeaea;
    font-family: bariol !important;
    font-size: 1.25rem !important;
    color: #333;
}

.titulo {
    font-size: 1.5rem !important;
}

.container {
    height: 100vh;
    background-color: white;
}

.text-bold {
    font-weight: bold !important;
}

.mw-200 {
    min-width: 200px;
}

.mh-100vh {
    min-height: 100vh;
}

.card-body {
    padding: 0.5rem !important;
}

@media only screen and (max-width: 600px) {
    .titulo {
        font-size: 1.25rem;
    }
}

iframe {
    height: 800px;
}
</style>
